<template>
    <v-card outlined>
        <v-toolbar flat>
            <v-toolbar-title class="text-uppercase body-1 font-weight-medium">Facilities</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>

            <div class="flex-grow-1"></div>

            <!-- search ~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
            <v-col cols="3" sm="3" md="3">
              <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Search"
                  single-line
                  hide-details
              ></v-text-field>
            </v-col>
        </v-toolbar>

        <!-- content -->
        <v-data-table
            :headers="headers"
            :items="items"
            :search="search"
            :sort-by="['account_id']"
            :sort-desc="[false]"
            :items-per-page="15"
            item-key="account_od"
            multi-sort
            dense
            >
            <!-- header ~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
            <template v-slot:top>
              <p>&nbsp;</p>
            </template>

            <!-- no-data ~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
            <template slot="no-data" class="text-left">
                <span class="subheading text-left">
                    <v-icon color="orange">warning</v-icon>
                    No facilities found.
                </span>
            </template>

            <template v-slot:item.address1="{ item }">
              {{ item.address1 }} {{ item.address2 }}<br/>
              {{ item.city }}, {{ item.state }} &nbsp;&nbsp; {{item.zipcode}}
            </template>

      </v-data-table>

    </v-card>
  </v-container>
</template>

<script>
import FacilityService from '@/services/FacilityService'
export default {
  name: 'ListFacilities',
  data() {
    return {
      items: [],
      search: '',
        headers: [
          {
            text: 'ID',
            align: 'center',
            sortable: true,
            value: 'facility_id'
          },
          {
            text: 'NAME',
            align: 'left',
            sortable: true,
            value: 'description'
          },
          {
            text: 'ADDRESS',
            align: 'left',
            sortable: false,
            value: 'address1'
          },
          {
            text: 'TZ',
            align: 'left',
            sortable: false,
            value: 'timezone'
          },
          {
            text: 'UTILITY',
            align: 'center',
            sortable: true,
            value: 'utility_id'
          }
        ] 
    }
  },
  created() {
    this.fetchFacilities()
  },
  methods: {
    fetchFacilities() {
      FacilityService.getFacilities()
        .then(response => {
          this.items = response.data
          console.log(this.items)
          this.$toast.info("Loaded " + this.items.length + " facilities.")
        })
        .catch(error => { this.$toast.error("Error loading facility data. " + error.message) })
    }
  }
}
</script>
